module.exports = __webpack_public_path__ + "static/media/bijb.5437f891.png";